<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
              <div class="card-header-actions">
                <div class="col-12 col-lg-4 col-sm-6 card-header-select-box mt-2 mt-sm-0 pl-0">
                  <div class="form-group">
                    <label>{{$t('client.field.province')}} <span class="red">*</span></label>
                    <v-select
                        label="name"
                        v-model="province"
                        :filterable="false"
                        :options="provinces"
                        @search="onProvinceSearch"
                        @search:focus="onProvinceFocus"
                        @change="onChangeFilterProvince"
                    >
                      <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                    </v-select>
                  </div>
                </div>
                <div class="col-12 col-lg-4 col-sm-6 card-header-select-box mt-2 mt-sm-0 pl-0">
                  <div class="form-group">
                    <label>{{$t('client.field.region')}} <span class="red">*</span></label>
                    <v-select
                        label="name"
                        v-model="region"
                        :filterable="false"
                        :options="regions"
                        @search="onRegionSearch"
                        @search:focus="onRegionFocus"
                        @change="onChangeFilterRegion"
                    >
                      <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                    </v-select>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-12 mt-1 mt-sm-0 pl-0">
                  <div class="form-group">
                    <button class="all-btn" @click="onSearch">
                      <i class="fa fa-search"></i>
                      <span>{{$t('main.search')}}</span>
                    </button>
                  </div>
                </div>
                <div class="col-12 justify-content-end mt-md-0 mt-2 card-header-btns-box">
                  <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_REGION_BORDER_ADD')" @click="edit(null)">{{$t("action.add")}}</button>
                </div>
              </div>
            </div>
            <div class="col-12">
                <div class="table-wrapper">
                  <table class="table table-hover">
                      <thead>
                          <tr>
                              <th>Вилоят</th>
                              <th>Туман</th>
                              <th>Чегарадош туманлар</th>
                              <th>Киритилган сана</th>
                              <!--<th class="text-center">{{$t("realEstate.field.action")}}</th>-->
                          </tr>
                      </thead>
                      <tbody v-if="!loading && results && results.data">
                          <tr v-for="result in results.data" :key="result.id">
                              <td><span v-if="result.data.province">{{result.data.province.label}}</span></td>
                              <td><span v-if="result.data.region">{{result.data.region.label}}</span></td>
                              <td>
                                {{getBorderRegionsNames(result.data)}}
                              </td>
                              <td>{{new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}</td>
                              <!-- <td class="td-actions text-center">
                                  <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="edit(result)">
                                      <i class="fa fa-edit"></i>
                                  </button>
                              </td> -->
                          </tr>
                      </tbody>
                  </table>
                </div>
                <div class="text-center">
                    <div class="loader mt-5 mb-5" v-if="loading"></div>
                    <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                </div>
                <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                    <div class="col-12 pt-3 pb-3">
                        <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                        </b-pagination>
                    </div>
                </div>
            </div>
            <RegionBordersSettingModal @change="initList"></RegionBordersSettingModal>
        </div>
    </div>
</template>

<script>
    import RegionBordersSettingModal from '@/views/config/real-estate/RegionBordersSettingEditModal'
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    export default {
        components: {
            RegionBordersSettingModal,
            'b-pagination': bPagination
        },
        data() {
          return {
            loading: false,
            filter: initFilterModel(),
            filterRegion: initFilterModel(),
            filterProvince: initFilterModel(),
            results: null,
            regions: [],
            province: null,
            region: null,
            provinces: [],
            allRegions: []
          }
        },
        computed: {

        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('dictionary/real-estate/analog-setting/list/REGION_BORDERS_SETTING', this.filter)
                    .then(res => {
                        this.results = res.data;
                        if (!this.allRegions.length) {
                          this.initRegion();
                        }
                        vm.loading = false;
                    }, err => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            initRegion() {
              this.allRegions = [];
              this.filterRegion.provinceId = null;
              this.$http.post('/region/search', this.filterRegion)
                  .then(res => {
                    this.allRegions = res.data.data;
                  }, err => {
                    console.log(err);
                  });
            },
            edit(data) {
                this.$eventBus.$emit("showRegionBordersSettingsModal",data)
            },
            getBorderRegionsNames(data) {
                if (this.allRegions.length > 0) {
                    let borderRegions = '';
                        data.borderRegions.forEach(value => {
                            this.allRegions.forEach(region => {
                                if (region.id === value) {
                                    if (borderRegions.length > 0) {
                                        borderRegions += ", ";
                                    }
                                    borderRegions+= region.name;
                                }
                            });
                        });
                    return borderRegions;
                }
                return '';
            },
            onSearch() {
              this.filter.page.page = 1
              this.filter.province = this.province;
              this.filter.region = this.region;
              this.initList()
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onChangeFilterProvince() {
              if (this.regions.length) this.regions = [];
              if (this.region) this.region = null
              this.filter.region = null
              this.filter.province = null

              if (this.province) {
                this.filter.province = this.province.code
              }
            },
            onChangeFilterRegion() {
              if (this.region) {
                this.filter.region = this.region.code
              }
              else {
                this.filter.region = null
              }
            },
            onProvinceFocus() {
              this.provinces = [];
              this.filterProvince.search = '';
              this.$http.post('/province/list', this.filterProvince)
                  .then(res => {
                    this.provinces = res.data.data;
                  }, err => {
                    console.log(err);
                  });
            },
            onProvinceSearch(searchTxt, loading) {
              loading(true);
              this.provinces = [];
              this.filterProvince.search = searchTxt;
              this.$http.post('/province/list', this.filterProvince)
                  .then(res => {
                    this.provinces = res.data.data;
                    loading(false);
                  }, err => {
                    console.log(err);
                  });
            },
            onRegionSearch(searchTxt, loading) {
              loading(true);
              this.regions = [];
              this.filterRegion.search = searchTxt;
              this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
              this.$http.post('/region/search', this.filterRegion)
                  .then(res => {
                    this.regions = res.data.data;
                    loading(false);
                  }, err => {
                    console.log(err);
                  });
            },
            onRegionFocus() {
              this.regions = [];
              this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
              this.$http.post('/region/search', this.filterRegion)
                  .then(res => {
                    this.regions = res.data.data;
                  }, err => {
                    console.log(err);
                  });
            },
        },
        created() {
            this.filterRegion.page.size = 10000;
            this.initList();
        }
    }
</script>

<style scoped>

</style>